import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Medicine } from 'src/app/models/medicine.model';
import { MedicineService } from 'src/app/services/medicine.service';

@Component({
  selector: 'app-confirm-prescription-dialog',
  templateUrl: './confirm-prescription-dialog.component.html',
  styleUrls: ['./confirm-prescription-dialog.component.css'],
  standalone: false
})
export class ConfirmPrescriptionDialogComponent implements OnInit {
  medicines: (Medicine & { isRestricted?: boolean; isArchived?: boolean })[];
  archivedMedicineExists: boolean;
  restrictedMedicineExists: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      medicines: Medicine[];
    },
    private matDialogRef: MatDialogRef<ConfirmPrescriptionDialogComponent>,
    private medicineService: MedicineService
  ) {
    this.medicines = data.medicines.map((medicine) => {
      if (this.medicineService.isArchived(medicine)) this.archivedMedicineExists = true;
      if (this.medicineService.isRestricted(medicine)) this.restrictedMedicineExists = true;

      return {
        ...medicine,
        isArchived: this.medicineService.isArchived(medicine),
        isRestricted: this.medicineService.isRestricted(medicine)
      };
    });
  }

  ngOnInit(): void {
    this.matDialogRef.addPanelClass('bg-dark');
  }
}
